<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 496.941 496.941" style="enable-background:new 0 0 496.941 496.941;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M276.329,2.259C274.824,0.753,272.565,0,271.059,0H36.894C16.565,0,0,16.565,0,37.647v421.647
				c0,20.329,16.565,37.647,36.894,37.647h330.541c20.329,0,36.894-16.565,36.894-37.647V146.824c0-1.506-0.753-3.765-2.259-5.271
				L276.329,2.259z M278.588,27.106l101.647,112.188H278.588V27.106z M390.023,459.294c0,12.047-9.788,22.588-21.835,22.588H36.894
				c-12.047,0-21.835-9.788-21.835-22.588V37.647c0-12.047,9.788-22.588,21.835-22.588h226.635v131.765
				c0,4.518,3.012,7.529,7.529,7.529h118.965V459.294z"/>
			<path d="M70.024,206.306h103.906c4.518,0,7.529-3.012,7.529-7.529v-27.859c0-23.341-18.823-42.165-42.165-42.165h-12.8
				c18.824-2.259,33.882-18.824,33.882-38.4c0-21.082-17.318-38.4-38.4-38.4c-21.082,0-38.4,17.318-38.4,38.4
				c0,19.576,15.059,35.388,33.882,38.4h-12.8c-23.341,0-42.165,18.824-42.165,42.165v27.859
				C62.494,203.294,66.259,206.306,70.024,206.306z M98.635,91.106c0-12.8,10.541-23.341,23.341-23.341
				c12.8,0,23.341,10.541,23.341,23.341c0,12.8-10.541,23.341-23.341,23.341C109.176,114.447,98.635,103.906,98.635,91.106z
				 M77.553,170.918c0-15.059,12.047-27.106,27.106-27.106h34.635c15.059,0,27.106,12.047,27.106,27.106v20.329H77.553V170.918z"/>
			<path d="M66.259,265.035h112.188c4.518,0,7.529-3.012,7.529-7.529s-3.012-7.529-7.529-7.529H66.259
				c-4.518,0-7.529,3.012-7.529,7.529S61.741,265.035,66.259,265.035z"/>
			<path d="M60.988,314.729c0,4.518,3.012,7.529,7.529,7.529H332.8c4.518,0,7.529-3.012,7.529-7.529
				c0-4.518-3.012-7.529-7.529-7.529H68.518C64,307.2,60.988,310.212,60.988,314.729z"/>
			<path d="M334.306,360.659H70.024c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529h264.282
				c4.518,0,7.529-3.012,7.529-7.529S338.071,360.659,334.306,360.659z"/>
			<path d="M330.541,414.871H67.012c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529h264.282
				c4.518,0,7.529-3.012,7.529-7.529S335.059,414.871,330.541,414.871z"/>
			<path d="M246.965,212.329c-1.506-3.765-6.024-5.271-9.788-3.765c-3.765,1.506-5.271,6.024-3.765,9.788l20.329,42.165
				c0.753,2.259,3.012,3.765,5.271,4.518c2.259,0.753,4.518,0,6.776-1.506l74.541-66.259c3.012-3.012,3.765-7.529,0.753-10.541
				c-3.012-3.012-7.529-3.012-10.541-0.753l-67.012,59.482L246.965,212.329z"/>
			<path d="M457.788,115.2c-21.835,0-39.153,17.318-39.153,39.153v238.682v2.259l31.624,96.376c0.753,3.012,3.765,5.271,7.529,5.271
				s6.024-2.259,7.529-5.271l31.624-96.376v-2.259V154.353C496.941,132.518,479.623,115.2,457.788,115.2z M457.788,465.318
				l-21.082-64.753h42.165L457.788,465.318z M481.882,385.506h-48.188V195.012h48.188V385.506z M481.882,179.953h-48.188v-25.6
				c0-13.553,10.541-24.094,24.094-24.094c13.553,0,24.094,10.541,24.094,24.094V179.953z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
